import type { ReactNode } from 'react';

type KeyValueProps = {
    keyData: string;
    valueData: ReactNode;
    valueDataAddon?: ReactNode;
    isLink?: boolean;
    isNotGood?: boolean;
    isPremiumFeature?: string;
    onClick?: () => void;
};

export const KeyValue = ({
    keyData,
    valueData,
    valueDataAddon,
    isLink,
    isNotGood,
    isPremiumFeature,
    onClick,
}: KeyValueProps) => {
    return (
        <div className='display-flex justify-between gap-20 text-size-12 position-relative' onClick={onClick}>
            <div className='flex-1-1-0 relative'>{keyData}</div>
            <div className={`flex-1-1-0 text-medium ${isNotGood ? 'text-color-danger' : ''}`}>
                {isPremiumFeature ? (
                    <span className='badge badge-primary text-size-18 scale-50 transform-origin-left top--4 white-space-nowrap position-absolute'>
                        {isPremiumFeature}
                    </span>
                ) : (
                    <span className={`${isLink ? 'text-decoration-underline underline-offset-2 cursor-pointer' : ''}`}>
                        {valueData}
                    </span>
                )}
                {valueDataAddon}
            </div>
        </div>
    );
};
